var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 34,
    viewBox: "0 0 22 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_151_1462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6175 0L10.3894 0.774814V23.2561L10.6175 23.4837L21.0528 17.3153L10.6175 0Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6175 0L0.181824 17.3153L10.6175 23.4837V12.5719V0Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6175 25.4594L10.4889 25.6162V33.6244L10.6175 33.9997L21.0592 19.2942L10.6175 25.4594Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6175 33.9997V25.4594L0.181824 19.2942L10.6175 33.9997Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6175 23.4838L21.0528 17.3154L10.6175 12.572V23.4838Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.181824 17.3154L10.6175 23.4838V12.572L0.181824 17.3154Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_151_1462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8774,
    height: 34,
    fill: "white",
    transform: "translate(0.181824)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthIcon);
export default __webpack_public_path__ + "static/media/EthIcon.6dab25a8be15faad555f1cd4c66d429c.svg";
export { ForwardRef as ReactComponent };